import React, { Component } from 'react';
import { Modal } from 'antd';
import styles from './index.less';

const star0 = 'https://s.xiaoyuanhao.com/image/micro/star_0.png';
const starFull = 'https://s.xiaoyuanhao.com/image/micro/star_full.png';
const starHalf = 'https://s.xiaoyuanhao.com/image/micro/star_half.png';

export default class RuleModal extends Component {
  render() {
    const { showModal, onCancel } = this.props;
    return (
      <Modal
        visible={showModal}
        title="规则说明"
        centered
        wrapClassName={styles['rule-modal']}
        width={700}
        footer={[]}
        onCancel={() => onCancel()}
      >
        <div className="common">
          按照各组织模版配置、发布资讯数、发布资讯天数累计的总分进行排序，排序每日更新一次，每月重新统计一次；总分：满分按100分计
        </div>
        <div className="common">
          <b>本月总分= </b>模版设置（10）+资讯发布数（40）+资讯发布天数（40）+连续发布天数分值（10）
        </div>
        <div className="rule-title">1、分值规则：</div>
        <div>
          <div className="common rule-item">
            <b>模版设置10分：</b>完成学校的模版选择配置后+10分
          </div>
          <div className="common rule-item">
            <b>资讯发布数40分：</b>
            截止每日统计，资讯未撤回或者删除，每发布一篇资讯积分+2分，超过20篇 后不计分
          </div>
          <div className="common rule-item">
            <b>资讯发布天数40分：</b>
            截止每日统计，资讯未撤回或者删除，每发布一天积分+4分，超过10天后 不计分
          </div>
          <div className="common rule-item">
            <b>连续发布资讯天数10分：</b>
            一个月中任意连续有效发布资讯5天，积分+10
          </div>
        </div>
        <div className="rule-title">2、分值对应星级：</div>
        <div className="star-wrap">
          <div className="star">
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <span>91-100分</span>
          </div>
          <div className="star">
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <img src={starHalf} alt="" />
            <span>81-90分</span>
          </div>
          <div className="star">
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <span>71-80分</span>
          </div>
          <div className="star">
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <img src={starHalf} alt="" />
            <span>61-70分</span>
          </div>
          <div className="star">
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <span>51-60分</span>
          </div>
          <div className="star">
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <img src={starHalf} alt="" />
            <span>41-50分</span>
          </div>
          <div className="star">
            <img src={starFull} alt="" />
            <img src={starFull} alt="" />
            <span>31-40分</span>
          </div>
          <div className="star">
            <img src={starFull} alt="" />
            <img src={starHalf} alt="" />
            <span>21-30分</span>
          </div>
          <div className="star">
            <img src={starFull} alt="" />
            <span>11-20分</span>
          </div>
          <div className="star">
            <img src={starHalf} alt="" />
            <span>1-10分</span>
          </div>
          <div className="star">
            <img src={star0} alt="" />
            <span>0分</span>
          </div>
        </div>
      </Modal>
    );
  }
}
